import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { useAuth } from "@/context/AuthContext";
import { apiError } from "@/lib/api";
import { AuthShell } from "@/pages/Login";
import { Loader2 } from "lucide-react";

export default function Register() {
  const { register } = useAuth();
  const navigate = useNavigate();
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await register(name, email, password);
      navigate("/onboarding");
    } catch (err) {
      setError(apiError(err.response?.data?.detail) || "Sign up failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthShell title="Start your bakery" subtitle="Create your account — 14-day free trial, no credit card required.">
      <form onSubmit={submit} className="space-y-4" data-testid="register-form">
        <div>
          <Label htmlFor="name" className="text-cocoa">Your name</Label>
          <Input id="name" value={name} onChange={(e) => setName(e.target.value)} required className="mt-1.5 rounded-xl bg-warmwhite" data-testid="register-name" />
        </div>
        <div>
          <Label htmlFor="email" className="text-cocoa">Email</Label>
          <Input id="email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required className="mt-1.5 rounded-xl bg-warmwhite" data-testid="register-email" />
        </div>
        <div>
          <Label htmlFor="password" className="text-cocoa">Password</Label>
          <Input id="password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} required minLength={6} className="mt-1.5 rounded-xl bg-warmwhite" data-testid="register-password" />
          <p className="mt-1 text-xs text-cocoa/50">At least 6 characters.</p>
        </div>
        {error && <p className="text-sm text-destructive" data-testid="register-error">{error}</p>}
        <Button type="submit" disabled={loading} className="w-full rounded-full bg-terracotta py-6 text-warmwhite hover:bg-terracotta/90" data-testid="register-submit">
          {loading ? <Loader2 className="h-4 w-4 animate-spin" /> : "Create account"}
        </Button>
      </form>
      <p className="mt-6 text-center text-sm text-cocoa/60">
        Already have an account? <Link to="/login" className="font-medium text-terracotta hover:underline" data-testid="register-to-login">Sign in</Link>
      </p>
    </AuthShell>
  );
}
